<div class="container">
    <h1>Editar producto</h1>

    <form (ngSubmit)="onSubmit()" #productForm="ngForm">
        <div class="mb-3 row">
            <label for="type-product" class="col-sm-4 col-form-label">
                Tipo de producto
                <sup class="text-danger">*</sup>
            </label>
            <div class="col-sm-8">
                <select
                    class="form-select"
                    id="type-product"
                    name="selectedProduct"
                    required
                    [disabled]="true">
                    <option>
                        {{ currentProductEdit?.tipoProducto?.nombre }}
                    </option>
                </select>
            </div>
        </div>

        <div class="mb-3 row">
            <label for="ica-number" class="col-sm-4 col-form-label">
                Número registro ICA
                <sup class="text-danger">*</sup>
            </label>
            <div class="col-sm-8">
                <input
                    type="text"
                    class="form-control"
                    id="ica-number"
                    [(ngModel)]="icaNumber"
                    [disabled]="isIcaNumberDisabled"
                    name="icaNumber"
                    [required]="!isIcaNumberDisabled"
                    pattern="[A-Z0-9]+"
                    maxlength="20" />
            </div>
            <div
                *ngIf="
                    !isIcaNumberDisabled &&
                    productForm.submitted &&
                    !productForm.controls['icaNumber'].valid
                "
                class="text-danger">
                ¡Numero ICA requerido!
            </div>
            <div
                *ngIf="
                    !isIcaNumberDisabled &&
                    productForm.controls['icaNumber']?.dirty &&
                    !productForm.controls['icaNumber']?.valid
                "
                class="text-danger">
                Sólo dígitos y letras mayúsculas, sin espacios ni caracteres
                especiales
            </div>
        </div>

        <app-input
            label="Nombre comercial del producto"
            inputId="nombreComercial"
            name="commercialName"
            [(ngModel)]="commercialName"
            [required]="true"
            [submitted]="productForm.submitted"
            [requiredMayusculas]="true"
            placeholder="Nombre registrado ante el ICA."
            tooltip="Se debe registrar el nombre del producto como se encuentra registrado ante el ICA."
            requiredError="¡Nombre comercial requerido!">
        </app-input>

        <div class="mb-3 row">
            <label for="casaProductora" class="col-sm-4 col-form-label">
                Nombre de la casa productora / Planta productora
                <sup class="text-danger">*</sup>
            </label>
            <div class="col-sm-8">
                <input
                    type="text"
                    class="form-control"
                    id="casaProductora"
                    [(ngModel)]="casaProductora"
                    name="casaProductora"
                    required />
            </div>
            <div
                *ngIf="
                    productForm.submitted &&
                    !productForm.controls['casaProductora'].valid
                "
                class="text-danger">
                ¡Nombre casa comercial requerido!
            </div>
        </div>

        <div class="mb-3 row" *ngIf="selectedTypeProduct !== '4'">
            <label for="product-origin1" class="col-sm-4 col-form-label">
                Origen del producto
                <sup class="text-danger">*</sup>
            </label>
            <div class="col-sm-8">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="radio"
                        name="productOrigin"
                        id="productOrigin1"
                        value="Producto Nacional"
                        [(ngModel)]="origenDelProducto" />
                    <label class="form-check-label" for="productOrigin1">
                        Producto Nacional
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="radio"
                        name="productOrigin"
                        id="productOrigin2"
                        value="Producto importado"
                        [(ngModel)]="origenDelProducto" />
                    <label class="form-check-label" for="productOrigin2">
                        Producto Importado
                    </label>
                </div>
            </div>
        </div>

        <div *ngIf="selectedTypeProduct === '1'">
            <div
                class="mb-3 row"
                *ngIf="origenDelProducto === 'Producto importado'">
                <label class="col-sm-4 col-form-label">País de origen</label>
                <div class="col-sm-8">
                    <ng-select
                        [items]="countries"
                        bindLabel="name"
                        bindValue="name"
                        name="countryOrigin"
                        [(ngModel)]="countryOrigin"
                        placeholder="Selecciona un país"
                        [searchable]="true"
                        [clearable]="true"></ng-select>
                </div>
            </div>
        </div>

        <div *ngIf="selectedTypeProduct === '2'">
            <div
                class="mb-3 row"
                *ngIf="origenDelProducto === 'Producto importado'">
                <label class="col-sm-4 col-form-label">País de origen</label>
                <div class="col-sm-8">
                    <ng-select
                        [items]="countries"
                        bindLabel="name"
                        bindValue="name"
                        name="fertiyCountryOrigin"
                        [(ngModel)]="fertiyCountryOrigin"
                        placeholder="Selecciona un país"
                        [searchable]="true"
                        [clearable]="true"></ng-select>
                </div>
            </div>
        </div>

        <div *ngIf="selectedTypeProduct === '3'">
            <div
                class="mb-3 row"
                *ngIf="origenDelProducto === 'Producto importado'">
                <label class="col-sm-4 col-form-label">País de origen</label>
                <div class="col-sm-8">
                    <ng-select
                        [items]="countries"
                        bindLabel="name"
                        bindValue="name"
                        name="coadyuvanteCountryOrigin"
                        [(ngModel)]="coadyuvanteCountryOrigin"
                        placeholder="Selecciona un país"
                        [searchable]="true"
                        [clearable]="true"></ng-select>
                </div>
            </div>
            
        </div>

        <div *ngIf="selectedTypeProduct === '4'">
            <div class="mb-3 row">
                <label for="species-dropdown" class="col-sm-4 col-form-label">
                    Especie
                </label>
                <div class="col-sm-8">
                    <select
                        class="form-select"
                        id="species-dropdown"
                        [(ngModel)]="balanceFoodSpecie"
                        name="specie-selected"
                        required>
                        <option value="" disabled selected class="grayed-text">
                            Selecciona especie
                        </option>
                        <option
                            *ngFor="let option of optSpecieBalanceFood"
                            [value]="option.id">
                            {{ option.nombre }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="mb-3 row">
                <label
                    for="productive-stage-dropdown"
                    class="col-sm-4 col-form-label">
                    Etapa productiva
                </label>
                <div class="col-sm-8">
                    <select
                        class="form-select"
                        id="productive-stage-dropdown"
                        [(ngModel)]="balanceFoodProductiveStage"
                        name="productive-stage-selected"
                        required>
                        <option value="" disabled selected class="grayed-text">
                            Selecciona una etapa productiva
                        </option>
                        <option
                            *ngFor="let option of optProductiveStage"
                            [value]="option.nombre">
                            {{ option.nombre }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div *ngIf="selectedTypeProduct === '5'">
            <div
                class="mb-3 row"
                *ngIf="origenDelProducto === 'Producto importado'">
                <label class="col-sm-4 col-form-label">País de origen</label>
                <div class="col-sm-8">
                    <ng-select
                        [items]="countries"
                        bindLabel="name"
                        bindValue="name"
                        name="acondicionadorEnmiendaCountryOrigin"
                        [(ngModel)]="acondicionadorEnmiendaCountryOrigin"
                        placeholder="Selecciona un país"
                        [searchable]="true"
                        [clearable]="true"></ng-select>
                </div>
            </div>
        </div>

        <button type="submit" class="btn btn-success float-right">
            Guardar
        </button>
    </form>
</div>
